import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field "),
  fullName: Yup.string().required("Name is required "),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  // .min(10, "number must be 10 digit")
  // .max(10, "number must be 10 digit"),
  // password: Yup.string().required("Password is required"),
  // .matches(
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
  //   "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
  // )
});
export const AdminLoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  // .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field "),
});
export const cpLoginSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field "),
});
export const SignUpSchema = Yup.object().shape({
  fullName: Yup.string()
    // .max(30, "Must be 15 characters or less")
    .required("Name is required "),
  mobile: Yup.string()
    .required("number  is required")
    // .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
  // .matches(/^-?d*.?d*$/, "String value is not required."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  state: Yup.string()
    .required("state is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
  country: Yup.string()
    .required("country is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
  city: Yup.string()
    .required("city is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
  password: Yup.string()
    .required("Please Enter your password")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  //   confirmPassword: Yup.string()
  //     .required()
  //     .oneOf([Yup.ref("password"), null], "Passwords must match"),
  //   .matches(
  //     "^(?=.*[A-Za-z])(?=.*d)[A-Za-zd]{8,}$",
  //     "Minimum eight characters, at least one letter and one number"
  //   ),
});

export const userSignUpSchema = Yup.object().shape({
  fullName: Yup.string()
    // .max(30, "Must be 15 characters or less")
    .required("Name is required "),
  mobile: Yup.string()
    .required("number  is required")
    // .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
  // .matches(/^-?d*.?d*$/, "String value is not required."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  state: Yup.string()
    .required("state is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
  country: Yup.string()
    .required("country is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
  city: Yup.string()
    .required("city is required")
    .matches(/^[aA-zZ\s]+$/, "Only charector are allowed for this field "),
});

export const partnerSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required "),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  mobile: Yup.string()
    .required("number  is required")
    // .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
  // .max(10, "number must be 10 digit"),
});

export const addCompanySchema = Yup.object().shape({
  name: Yup.string().required("Name is required "),
  urlName: Yup.string().required("URL Name is required "),
  totalAmount: Yup.number().required("Price is required "),
  minInvestment: Yup.number().required("minInvestment is required "),
  // .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field "),
  // region: Yup.string().required("Region is required "),
  sector: Yup.string().required("Sector is required "),
  status: Yup.string().required("Status is required "),
  isPortfolio: Yup.string().required("In Portfolio is required "),
  // portfolioType: Yup.string().required("In Portfolio Type is required "),
  // portfolioQuantity: Yup.string().required(
  //   "In Portfolio Quantity is required "
  // ),
  top: Yup.number().required("Top is required "),
  remainingPeriod: Yup.date().required("Remaining date is required "),
  isinCode: Yup.string().required("ISIN Code is required "),
});

export const careerSchema = Yup.object().shape({
  fullName: Yup.string().required("Name is required "),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  mobile: Yup.string()
    .required("number  is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field "),
  // .min(10, "number must be 10 digit")
  // .max(10, "number must be 10 digit"),
  position: Yup.string().required("Position is required "),
  resume: Yup.string().required("Resume is required "),
});
export const addUserSchema = Yup.object().shape({
  fullName: Yup.string().required("First Name is required "),
  // lastName: Yup.string().required("Last Name is required "),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  mobile: Yup.string()
    .required("Mobile number  is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
  // address: Yup.string().required("Address is required "),
  gender: Yup.string().required("Gender is required "),
  // nationality: Yup.string().required("Nationality is required "),
  // dateOfBirth: Yup.date().required("Date is required!"),
  // userState: Yup.string().required("Active is required "),
  // employementStatus: Yup.string().required("Employement Status is required!"),
  // wealthSource: Yup.string().required("Wealth Source is required!"),
  // howHearAboutUs: Yup.string().required("HowHear About Us is required!"),
});
export const addRealEstateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
  urlName: Yup.string().required("Url Name is required!"),
  totalAmount: Yup.number().required("Price is required"),
  minimunInvestment: Yup.number().required("Min Investment is required"),
  // averageRentalYield: Yup.number().required("Avg. Rental Yield is required"),
  sharePrice: Yup.number().required("Share Price is required"),
  remainingPeriod: Yup.date().required("Remaining Period is required"),
  propertyType: Yup.string().required("Property Type is required"),
  status: Yup.string().required("Status is required"),
});
export const addDocument = Yup.object().shape({
  customerId: Yup.string().required("Customer Id is required"),
  id: Yup.string().required("Id is required"),
});
export const addCPSchema = Yup.object().shape({
  fullName: Yup.string().required("Name is required "),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  mobile: Yup.string()
    .required("Mobile number  is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
});
export const addStaffSchema = Yup.object().shape({
  fullName: Yup.string().required("Name is required "),
  mobile: Yup.string()
    .required("Mobile number  is required")
    .matches(/^[0-9\s]+$/, "Only numbers are allowed for this field ")
    .min(7, "number must be min 7 digit")
    .max(15, "number must be max 15 digit"),
  employeeCode: Yup.string().required("Employee Code is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email Code is required"),
  featured_image: Yup.string().required("Featured Image Code is required"),
});
export const addExternalStockSchema = Yup.object().shape({
  companyName: Yup.string().required("Company Name is required "),
  sector: Yup.string().required("Sector is required "),
  price: Yup.string().required("Price is required "),
  quantity: Yup.string().required("Quantity is required "),
  stockDescription: Yup.string().required("External Stock is required "),
});

export const addBlogManagementSchema = Yup.object().shape({
  title: Yup.string().required("Name is required!"),
  urlTitle: Yup.string().required("Plan ID is required!"),
  sortDescription: Yup.string().required("Comapny Name is required!"),
  // tags: Yup.string().required("Tags is required!"),
  // date: Yup.date().required("Date is required!"),
  ogTitle: Yup.string().required("ogTitle is required!"),
  ogType: Yup.string().required("ogType is required!"),
  ogImage: Yup.string().required("ogImage is required!"),
  ogUrl: Yup.string().required("ogUrl is required!"),
  // featured_image: Yup.string().required("Image is required!"),
  ogDescription: Yup.string().required("ogDescription is required!"),
  metaTitle: Yup.string().required("Meta Title is required!"),
  metaDescription: Yup.string().required("Meta Description Title is required!"),
  metaKeywords: Yup.string().required("Meta Keywords Title is required!"),
  metaRobots: Yup.string().required(" Meta Robots is required!"),
  canonicalTag: Yup.string().required("Canonical Tag is required!"),
  content: Yup.string().required("Post Content is required!"),
});

export const categoryAndPlansSchema = Yup.object().shape({
  insurance_type: Yup.string().required('Insurance type is required'),
  company_name: Yup.string().required('Company name is required'),
  plan_detail: Yup.object().shape({
    planId: Yup.string().required('Plan ID is required'),
    plan_name: Yup.string().required('Plan name is required'),
    companyName: Yup.string().required('Company name is required'),
    logo: Yup.string().url('Logo must be a valid URL').required('Logo URL is required'),
    description: Yup.string().required('Plan description is required'),
  }),
  media: Yup.object().shape({
    image: Yup.string().url('Image must be a valid URL').required('Image URL is required'),
  }),
  addition_deatil: Yup.object().shape({
    deductible: Yup.string().required('Deductible is required'),
    benefits: Yup.string().required('Benefits description is required'),
    copay: Yup.object().shape({
      Copay_Applicable: Yup.string().required('Copay Applicable is required'),
      Copay_Value: Yup.string().required('Copay Value is required'),
    }),
    cashless_hospitals: Yup.string().required('Cashless hospitals are required'),
    policy_exclusion: Yup.array().of(Yup.object().shape({
      exclusion: Yup.string().required('Policy exclusion description is required'),
    })),
    CPA: Yup.string().required('CPA value is required'),
    Accessories: Yup.array().of(Yup.string().required('Accessory description is required')),
    Additional_Covers: Yup.array().of(Yup.string().required('Additional cover description is required')),
    Plan_specialty: Yup.string().required('Plan specialty is required'),
    Purpose_of_Travel: Yup.string().required('Purpose of travel is required'),
    faq: Yup.array().of(Yup.object().shape({
      heading: Yup.string().required('FAQ heading is required'),
      details: Yup.string().required('FAQ details are required'),
    })),
    reports: Yup.array().of(Yup.object().shape({
      name: Yup.string().required('Report name is required'),
      link: Yup.string().url('Report link must be a valid URL').required('Report link is required'),
    })),
  }),
  add_on: Yup.array().of(Yup.object().shape({
    // Define validations for each add-on object properties
  })),
  plan_pricing: Yup.object().shape({
    base_amt: Yup.string().required('Base amount is required'),
    discount: Yup.string().required('Discount is required'),
    active: Yup.string().required('Active status is required'),
  }),
  organize_detail: Yup.object().shape({
    category: Yup.string().required('Category is required'),
    plan_type: Yup.string().required('Plan type is required'),
    policy_type: Yup.string().required('Policy type is required'),
    premium: Yup.string().required('Premium type is required'),
    cover_range: Yup.string().required('Cover range is required'),
    pre_existing_diseases: Yup.string().required('Pre-existing diseases is required'),
  }),
  no_claim_bonus: Yup.array().of(Yup.object().shape({
    bonus_value: Yup.string().required('Bonus value is required'),
  })),
  Visa_Type: Yup.string().required('Visa type is required'),
  Claim_Settlement_ratio: Yup.string().required('Claim settlement ratio is required'),
  Plan_Video: Yup.string().url('Plan video must be a valid URL').required('Plan video URL is required'),
  ClaimInformation: Yup.object().shape({
    Cashless_Claim: Yup.object().shape({
      heading: Yup.string().required('Cashless claim heading is required'),
      details: Yup.string().required('Cashless claim details are required'),
    }),
    Document_Required: Yup.object().shape({
      heading: Yup.string().required('Required documents heading is required'),
      details: Yup.string().required('Required documents details are required'),
    }),
    Reimbursement_Claim: Yup.object().shape({
      heading: Yup.string().required('Reimbursement claim heading is required'),
      details: Yup.string().required('Reimbursement claim details are required'),
    }),
    Contact_No: Yup.string().required('Contact number is required'),
    Email_ID: Yup.string().email('Invalid email address').required('Email ID is required'),
    Claim_Form: Yup.string().url('Claim form must be a valid URL').required('Claim form URL is required'),
  }),
});

export const cashLessHospitals = Yup.object().shape({
  hospitalName: Yup.string().required("Hospital Name is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  phoneNumber: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .required("Phone Number is required")
    .min(10, "number must be min 10 digit")
    .max(10, "number must be max 10 digit"),
  pinCode: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .required("Pin Code is required"),
  // insurer: Yup.required("Insurer is required"),
  State: Yup.string().required("State is required"),
});
export const addinthenewsSchema = Yup.object().shape({
  title: Yup.string().required("Title is required!"),
  link: Yup.string().required("Link is required!"),
  description: Yup.string().required("Description is required!"),
});
export const addCpManagementSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required!"),
  email: Yup.string()
    .email("Invalid Email Address")
    .required("Email is required!"),
  mobile: Yup.number().required("Mobile is required!"),
});
